import { render } from "./inReview.vue?vue&type=template&id=c86b354a&scoped=true"
import script from "./inReview.vue?vue&type=script&lang=js"
export * from "./inReview.vue?vue&type=script&lang=js"

import "./inReview.vue?vue&type=style&index=0&id=c86b354a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c86b354a"]])

export default __exports__